import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-product-set-item-details" }
const _hoisted_3 = { "data-qa": "quantity" }
const _hoisted_4 = {
  class: "gfu-hd",
  "data-qa": "product-name"
}
const _hoisted_5 = {
  key: 0,
  class: "_pa-0 _flex _grow-1 _flex-basis-60"
}
const _hoisted_6 = { class: "_grow-1" }
const _hoisted_7 = {
  key: 0,
  class: "_ml-1 _mt-4"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_thumb = _resolveComponent("base-thumb")
  const _component_product_option_field = _resolveComponent("product-option-field")
  const _component_icon_base_button = _resolveComponent("icon-base-button")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-product-set-item-wrapper",
    "data-qa": 'product-set-item-details:'+ $props.productSetItemID
  }, [
    ($options.hasImage)
      ? (_openBlock(), _createBlock(_component_base_thumb, {
          key: 0,
          size: "small",
          "image-url": $options.imageUrl,
          alt: $options.name
        }, null, 8 /* PROPS */, ["image-url", "alt"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(['gfu-product-set-item-wrapper__content', {'gfu-product-set-item-wrapper__content--middle': !$options.hasOptions}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString($props.quantity) + "x ", 1 /* TEXT */),
        _createElementVNode("span", null, [
          _createElementVNode("strong", _hoisted_4, _toDisplayString($options.name), 1 /* TEXT */)
        ])
      ]),
      ($options.hasOptions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.options, (option, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'product-set-item-option-' + option.productOptionID
                }, [
                  _createVNode(_component_product_option_field, {
                    option: option,
                    "selected-option-value-id": option.productOptionValueID,
                    "currency-symbol": $props.currencySymbol,
                    "relative-factor-with-commission": $props.relativeFactorWithCommission,
                    "label-class": "gfu-field__label--light",
                    class: _normalizeClass({ '_mt-0': index === 0 }),
                    disabled: !$props.canChangeOptions,
                    onChange: $options.setSelectedProductOption
                  }, null, 8 /* PROPS */, ["option", "selected-option-value-id", "currency-symbol", "relative-factor-with-commission", "class", "disabled", "onChange"])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            ($props.showSplitColumn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  ($props.canProductBeSplit)
                    ? (_openBlock(), _createBlock(_component_icon_base_button, {
                        key: 0,
                        "icon-namespace": "ga",
                        icon: "split-icon",
                        "only-icon": true,
                        theme: "lightFlat",
                        shape: "circle",
                        title: "Split item",
                        onClick: _withModifiers($options.splitProductItem, ["prevent"]),
                        "data-qa": "split-button"
                      }, null, 8 /* PROPS */, ["onClick"]))
                    : _createCommentVNode("v-if", true),
                  ($props.canProductBeRemoved)
                    ? (_openBlock(), _createBlock(_component_icon_base_button, {
                        key: 1,
                        icon: "times",
                        "only-icon": true,
                        theme: "lightFlat",
                        shape: "circle",
                        title: "Undo split",
                        onClick: _withModifiers($options.removeProductItem, ["prevent"]),
                        "data-qa": "remove-button"
                      }, null, 8 /* PROPS */, ["onClick"]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ], 8 /* PROPS */, _hoisted_1))
}